import { Icon, ICONS, Spacer } from '@bob/library'
import { AssetProps } from '@websrc/App/Components/Asset/Asset'
import { useStaticText } from '@websrc/App/Hooks/useStaticText'
import { matomo } from '@websrc/App/Tracking/Matomo'
import { mapDistributorSpot } from '@websrc/DataMappers/mapSpot'
import { SpotDistributorCardDetails } from '@websrc/Spot/Distributor/Card/Details/SpotDistributorCardDetails'
import { SpotDistributorCardMainMarket } from '@websrc/Spot/Distributor/Card/MainMarket/SpotDistributorCardMainMarket'
import { StyledAnchor } from '@websrc/Spot/Link/SpotLink.style'
import React from 'react'

import * as SC from './SpotDistributorCard.style'

export interface SpotDistributorCardProps {
  distributor: ReturnType<typeof mapDistributorSpot>['distributor']['markets'][0]['distributors'][0]
  authorizedAsset: AssetProps | null
  isMainMarket: boolean
}

export const SpotDistributorCard = ({
  distributor,
  authorizedAsset,
  isMainMarket,
}: SpotDistributorCardProps) => {
  const t = useStaticText()
  const { details } = distributor

  return (
    <SC.Wrapper desktop={4} giant={3} tablet={6}>
      <SC.DistributorCard>
        <SC.Title>{distributor.name}</SC.Title>
        {authorizedAsset && <SC.AuthorizedLogo {...authorizedAsset} lazyLoading={false} />}
        {details && (
          <>
            {isMainMarket ? (
              <>
                <SpotDistributorCardDetails details={details} logo={distributor.logo} />
                <SpotDistributorCardMainMarket distributor={distributor} />
              </>
            ) : (
              <SpotDistributorCardDetails details={details} logo={distributor.logo} />
            )}
            {details.homepage && (
              <>
                <Spacer.Height size={20} />
                <SC.InfoWebsite>
                  <StyledAnchor
                    ctaType={'tertiary'}
                    ctaVariant={'blue'}
                    href={details.homepage}
                    onClick={() => {
                      matomo.trackEvent(
                        'engagement',
                        'Find Distributor page',
                        ['Go to site', 'link click', details.homepage],
                        ['Distributor name', distributor.name],
                        'link'
                      )
                    }}
                  >
                    <Icon icon={ICONS.ARROW_RIGHT} size={16} />
                    <span>{t.shop.go_to_site}</span>
                  </StyledAnchor>
                </SC.InfoWebsite>
              </>
            )}
          </>
        )}
      </SC.DistributorCard>
    </SC.Wrapper>
  )
}
